import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=72cc0f0c&scoped=true&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc0f0c",
  null
  
)

export default component.exports